import RGB from "../types/RGB.ts";

export default class Convert {
    //----------------------------------
    //  Public-Static:
    //----------------------------------

    public static hexToNumber(hex: string): number {
        return parseInt(hex.replace("#", "0x"));
    }

    public static hexToRgb(hex: string): RGB {
        // Expand shorthand form ("03F") to full form ("0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        const value = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        const result: RGB = new RGB();
        result.r = parseInt(value[1], 16);
        result.g = parseInt(value[2], 16);
        result.b = parseInt(value[3], 16);
        return result;
    }
}
